import React from 'react';
import { ResourceContextProvider } from '../contexts/ResourceContext';

interface FeatureProvidersProps {
  children: React.ReactNode;
}

export const FeatureProviders: React.FC<FeatureProvidersProps> = ({ children }) => {
  return (
    <ResourceContextProvider>
      {children}
    </ResourceContextProvider>
  );
};